export const login = (userInfo, apiKey) => {
    return {
        type: 'LOGIN',
        data: userInfo,
        apiKey: apiKey
    };
};

export const logout = () => {
    return {
        type: 'LOGOUT'
    };
};